<template>
    <div class="qr-view">
        <transition name="fade">
            <img :src="$env.getAppLogo().signet" />
        </transition>
    </div>
</template>
<script>
export default {
    data() {
        return {
            questionModalVisible: false
        }
    },
    computed: {
        token() {
            return this.$route.query.token
        },
        region() {
            return this.$route.query.region
        },
        lang() {
            return this.$route.query.lang ? this.$route.query.lang : 'en'
        }
    },
    methods: {
        handleQRToken() {
            if (this.region) {
                this.$store.commit('setRegion', this.region)
            }
            if (this.lang) {
                this.$Language.selectLanguage(this.lang)
            }
            let timeout = 0
            if (this.$Utils.isMobileDevice()) {
                this.handleUserWithApp()
                timeout = 1000
            }
            setTimeout(() => {
                this.handleUserWithoutApp()
            }, timeout)
        },
        handleUserWithApp() {
            window.location = `livekid://open-qr?token=${this.token}&region=${this.region}`
        },
        async handleUserWithoutApp() {
            try {
                await this.fetchInfoFromToken()
                const accountExists = await this.checkAccountExistence()
                accountExists === true
                    ? this.handleExistingAccount()
                    : this.handleNewAccount()
            } catch (error) {
                this.$router.push('/bad-qr')
            }
        },
        async fetchInfoFromToken() {
            return this.$api
                .get(`v1/qr/${this.token}`)
                .then(({ data }) => {
                    if (data.status == 'invalid') {
                        this.$Notif.error(this.$t('QR_NOT_VALID'))
                        return Promise.reject('invalid')
                    }
                    this.tokenData = data
                })
                .catch(error => {
                    return error
                })
        },
        async checkAccountExistence() {
            const mail = this.tokenData.mail
            if (!mail) {
                return Promise.reject()
            }
            return this.$api
                .get(`v1/accounts/exists/${mail}`)
                .then(({ data }) => {
                    return data
                })
                .catch(error => {
                    return error
                })
        },
        handleExistingAccount() {
            const timeout = this.$Utils.isMobileDevice() ? 1500 : 0
            switch (this.$Utils.mobileDeviceType()) {
                case 'android':
                    window.location =
                        'https://play.google.com/store/apps/details?id=com.livekidmobileadmin'
                    break
                case 'ios':
                    window.location =
                        'market://details?id=com.livekidmobileadmin&hl=pl'
                    break
            }
            setTimeout(() => {
                window.location = `${this.$env.getMainApp()}?token=${
                    this.token
                }&region=${this.region}&lang=${this.lang}`
            }, timeout)
        },
        handleNewAccount() {
            const { token, mail } = this.tokenData
            const queryMail = mail.replace('+', '%2B')
            const url = `/signup?region=${this.region}&type=parent&mail=${queryMail}&token=${token}`
            this.$router.push(url)
        }
    },
    mounted() {
        this.handleQRToken()
    }
}
</script>
<style lang="scss" scoped>
.qr-view {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
